export default function() {

    let ctrl = function($state, $stateParams) {
        "ngInject";

        $state.go('survey', $stateParams);
    };

    const template = `
        <div></div>
    `;

    return {
        restrict: 'E',
        scope: {
            saved: '='
        },
        template: template,
        controller: ctrl,
        controllerAs: 'surveyWithSlash'
    }
}



// WEBPACK FOOTER //
// ./app/components/survey-with-slash/survey-with-slash.directive.js